import React from 'react'
import linkedin from '../assets/linkedin.png'
import instagram from '../assets/instagram.png'
import github from '../assets/github.png'
import Logo from './logo.png';
import './Footer.css'

export default function Footer() {
  return (
    <div className="Footer-Container">
        <hr/>
        <div className="flexable">
        <div className="footer">
            <img src={github} alt="" />
            <img src={instagram} alt="" />
            <img src={linkedin} alt="" />
        </div>

        <div className="logo-f">
            <img src={Logo} alt="" />
        </div>
          
        </div>
        <div className="blur blur-footer-1"></div>
        <div className="blur blur-footer-2"></div>
    </div>
  )
}
